/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { Button } from 'react-bootstrap';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';

const CustomButton = ({ btnTitle, onClick, icon, btnWidthCss }) => {
  return (
    <div className="">
      <div className="float-right hide-on-print">
        <Button
          className={
            btnWidthCss
              ? `btn btn-success btn-view ${btnWidthCss}`
              : `btn btn-success ${btnWidthCss}`
          }
          onClick={onClick}
        >
          &nbsp;
          <SVGComponent iconName={icon} />
          {btnTitle}
        </Button>
      </div>
    </div>
  );
};

export default CustomButton;
